enum RadioValues {
  Custom,
  All,
  NoDuplicate,
  PasteIds,
}

export default RadioValues;
